import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSpeedex({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M10.62 11.55s3.176-1.394 8.052-.989c-.883-.362-2.621-.362-4.097-.32.377-.134 2.365-.555 4.944-.054 1.567.296 2.244.927 2.244.927s.607.85-.677 1.142c.085-.428-.054-.567-.26-.638-.207-.07-3.417-1.27-10.205-.068zM4.44 11.892H2.964c-.3 0-.465.048-.536.28-.07.233-.07.272-.143.551-.044.176-.09.43.278.43h1.379s.116 0 .116.095 0 .155-.116.155h-1.81l-.107.532 2.123.013s.383-.013.482-.358c.099-.346.145-.59.145-.59s.077-.365-.335-.365H3.167c-.167 0-.203.021-.203-.112 0-.118.133-.118.203-.118h1.165l.108-.513z"
        fill="#007B42"
      />
      <path
        d="M4.7 11.887l-.104.504H6.86c.183 0 .222 0 .222.144 0 .09-.092.117-.222.117H5.053l-.302 1.281h.693l.179-.778h1.46c.23 0 .457.018.56-.357.104-.375.125-.496.125-.496s.119-.415-.46-.415H4.701zM10.181 11.891H8.833c-.276 0-.784.03-.946.558-.171.524-.201.82-.201.82s-.128.669.442.669h1.684l.111-.536H8.641c-.165 0-.327 0-.327-.092v-.114c0-.016-.003-.06.067-.06h1.522L10 12.63H8.436s.105-.218.166-.234c.061-.016 1.462 0 1.462 0l.117-.506zM12.227 11.899h-1.02c-.277 0-.786.03-.947.558-.171.524-.201.82-.201.82s-.128.669.442.669h1.726l.095-.536h-1.308c-.164 0-.327 0-.327-.092v-.114c0-.016-.003-.06.067-.06h1.533l.102-.505h-1.58s.105-.218.166-.234c.061-.016 1.188 0 1.188 0l.064-.506zM12.495 11.881l-.109.535h1.894c.08 0 .416 0 .394.207-.02.24-.1.505-.1.505s-.083.277-.523.277h-.901l.163-.753-.605-.02-.282 1.316h1.772s.832-.064.986-.582c.154-.518.167-.59.202-.866.05-.373-.07-.581-.771-.596-.996 0-2.12-.023-2.12-.023z"
        fill="#007B42"
      />
      <path
        d="M17.852 11.899h-1.348c-.276 0-.785.03-.947.558-.17.524-.2.82-.2.82s-.128.669.442.669h1.684l.111-.536h-1.283c-.164 0-.326 0-.326-.092v-.114c0-.016-.003-.06.067-.06h1.521l.098-.505h-1.564s.105-.218.166-.234c.061-.016 1.461 0 1.461 0l.118-.506zM17.884 11.885l.86.995-1.244 1.039h1.047l.65-.553.495.582h.905l-.882-.988 1.295-1.075h-1.05l-.667.576-.526-.576h-.883z"
        fill="#082172"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.087 11.124l-.02.075h-.128l-.058.419h-.094l.059-.419h-.132l.011-.075h.362zM3.427 11.618l-.014-.115H3.25l-.046.115h-.097l.222-.494h.114l.082.494h-.098z"
        fill="#007B42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.26 11.432h.125l-.03-.24-.096.24z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.143 11.124l-.163.228.107.266h-.1l-.07-.204-.124.204H3.69l.179-.263-.097-.231h.1l.058.173.111-.173h.102zM4.645 11.124l-.2.306-.026.188h-.094l.027-.187-.114-.307h.1l.07.23.136-.23h.101zM5.248 11.618h-.09l.016-.209c.006-.08.013-.148.022-.204l-.14.359h-.088l-.045-.358a1.498 1.498 0 01-.031.21l-.04.202h-.09l.108-.494h.115l.04.35.13-.35h.124l-.03.494zM5.828 11.124l-.02.07h-.18l-.02.138h.157l-.009.07H5.6l-.02.145h.192l-.01.07h-.286l.07-.493h.282zM6.385 11.124l-.02.075h-.128l-.059.419h-.093l.058-.419h-.131l.01-.075h.363zM6.749 11.618l-.015-.115h-.162l-.046.115h-.097l.221-.494h.114l.083.494h-.098z"
        fill="#007B42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6 11.432h.126l-.03-.24-.096.24z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.554 11.349a.204.204 0 01-.11.183.32.32 0 01-.149.034l-.007.052h-.09l.007-.053a.245.245 0 01-.15-.05.152.152 0 01-.053-.122.21.21 0 01.026-.102.205.205 0 01.084-.08.324.324 0 01.148-.035l.007-.052h.09l-.007.053c.065.003.115.02.15.05.036.03.054.071.054.122z"
        fill="#007B42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.097 11.395c0 .034.01.06.03.079.02.018.05.028.09.03l.037-.267c-.058.005-.099.022-.122.052a.17.17 0 00-.035.106zM7.3 11.505c.06-.004.1-.022.124-.053a.174.174 0 00.035-.107.1.1 0 00-.03-.077c-.02-.019-.05-.029-.09-.03l-.039.267z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.956 11.113c.058 0 .103.018.135.053a.211.211 0 01.049.149.439.439 0 01-.025.145.272.272 0 01-.082.12.215.215 0 01-.145.048.175.175 0 01-.135-.052.21.21 0 01-.048-.149c0-.048.008-.096.025-.144a.277.277 0 01.081-.12.213.213 0 01.145-.05z"
        fill="#007B42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.95 11.185a.11.11 0 00-.088.04.235.235 0 00-.047.098.475.475 0 00-.014.11c0 .082.03.123.092.123a.11.11 0 00.09-.04.237.237 0 00.046-.098.476.476 0 00.013-.11c0-.043-.007-.074-.023-.094-.015-.02-.038-.029-.069-.029z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.507 11.124c.057 0 .1.011.132.034.031.023.047.056.047.1a.196.196 0 01-.022.092.167.167 0 01-.07.069.251.251 0 01-.123.026h-.058l-.024.173h-.094l.07-.494h.142z"
        fill="#007B42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.47 11.375c.044 0 .074-.011.092-.033a.125.125 0 00.026-.08c0-.025-.007-.042-.022-.053a.113.113 0 00-.067-.016h-.05l-.026.182h.048z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.138 11.113l-.02.07h-.18l-.02.138h.157l-.01.07H8.91l-.02.145h.192l-.01.07h-.285l.069-.493h.283zM9.643 11.113l-.01.072h-.21l.108.159-.006.046-.149.144h.209l-.01.073h-.313l.01-.072.17-.172-.12-.178.01-.072h.311z"
        fill="#007B42"
      />
    </svg>
  )
}

export default SvgSpeedex
